import { withProtectedResource } from '@delmonicos/shared-design-system-react/src/components/protected-resources/with-protected-resource.helper';
import { safeHasAccessTo } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/tariffs/tariff.model';
import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';
import { useEmspBoGetTariffQuery } from '@service/emsp-bo-tariff.service';
import { useSetPageTitleContext } from '@shared/layout/page-layout/page-layout-title.context-provider';

import { EmspBoTariffDetailsView } from './emsp-bo-tariff-details.view';

interface EmspBoTariffDetailsControllerProps {
  resource: TariffModel;
}

const EmspBoTariffDetailsController = ({
  resource,
}: EmspBoTariffDetailsControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // PAGE TITLE ////////////////////////////////////////////////////////////////

  const setPageTitle = useSetPageTitleContext();

  useEffect(() => {
    setPageTitle(resource.id);
  }, [resource, setPageTitle]);

  // PAGE ACTIONS //////////////////////////////////////////////////////////////

  // Nothing to do

  // PAGE BREADCRUMB ///////////////////////////////////////////////////////////

  // Nothing to do

  // HANDLERS //////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return <EmspBoTariffDetailsView resource={resource} />;
};

export const EmspBoTariffDetailsPage = (): React.JSX.Element => {
  const userPermissions = useAppSelector(permissions);
  const params = useParams();
  const [searchParams] = useSearchParams();

  const cpoId = searchParams.get('cpoId') ?? '';
  const queryState = useEmspBoGetTariffQuery(
    { tariffId: params.id ?? '', cpoId },
    { skip: !params.id || !cpoId },
  );

  const { Component } = withProtectedResource<TariffModel, {}, TariffModel>(
    EmspBoTariffDetailsController,
    queryState,
    {
      isAuthorized: () =>
        safeHasAccessTo(userPermissions, {
          resourceName: Resource.EMSP_BO,
          action: ActionsByResource.EMSP_BO.READ_TARIFF,
        }),
    },
  )({});

  return Component;
};
